import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '../../../base/ui/components/web/Button';
import AbstractPollsPane from '../AbstractPollsPane';
import PollCreate from './PollCreate';
import PollsList from './PollsList';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
import { isLocalParticipantModerator } from '../../../base/participants';
import { useSelector } from 'react-redux';
import { getBrandingColorPalette } from '../../../base/styles';
/* eslint-enable lines-around-comment */
const useStyles = makeStyles()(() => {
    return {
        container: {
            position: 'relative',
            maxHeight: "calc(100vh - 240px)",
        },
        listContainer: {
            height: 'calc(100% - 80px)',
            overflowY: 'auto',
            scrollbarWidth: 'thin'
        },
        footer: {
            position: 'absolute',
            padding: '24px',
            width: '100%',
            boxSizing: 'border-box'
        }
    };
});
const PollsPane = ({ createMode, onCreate, setCreateMode, t }) => {
    var _a;
    const { classes } = useStyles();
    const interfaceConfig = useSelector(state => state['features/base/config'].interfaceConfig);
    const isModerator = useSelector(state => isLocalParticipantModerator(state));
    const createPollStyle = {
        backgroundColor: (_a = getBrandingColorPalette(interfaceConfig)) === null || _a === void 0 ? void 0 : _a.primary,
    };
    return createMode
        ? React.createElement(PollCreate, { setCreateMode: setCreateMode })
        : React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.listContainer },
                React.createElement(PollsList, null)),
            React.createElement("div", { className: classes.footer }, isModerator && (React.createElement(Button, { accessibilityLabel: t('polls.create.create'), fullWidth: true, style: createPollStyle, labelKey: 'polls.create.create', onClick: onCreate, type: BUTTON_TYPES.SECONDARY }))));
};
/*
 * We apply AbstractPollsPane to fill in the AbstractProps common
 * to both the web and native implementations.
 */
export default AbstractPollsPane(PollsPane);
